import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";

const userMembercard = {
  state: {
    listUserMembercard: [],
    listMembercard: [],
    listOrderUserMembercard: [],
    userMemberCard: {},
    total: 0,
    count: 0,
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async getListUserMembercard(payload, rootState) {
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI +
          Channel +
          "/api/secure/userMembercards/getListUserMembercard",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(payload),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1)
            this.setState({
              listUserMembercard: result.data.list,
              listMembercard: result.data.listMembercard,
              total: result.data.total,
              count: result.data.count,
            });
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async checkSentUserMembercard(payload, rootState) {
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI +
          Channel +
          "/api/secure/userMembercards/checkSentUserMembercard",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(payload),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async deleteUserMembercard(payload, rootState) {
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      let data = {
        _id: payload._id,
      };
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI +
          Channel +
          "/api/secure/userMembercards/deleteUserMembercard",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async sendMembercardForPhoneList(payload, rootState) {
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      let data = {
        phoneList: payload.phoneList,
        memberCardSend: payload.memberCardSend,
        methodSend: payload.methodSend,
      };
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI + Channel + "/api/secure/userMembercards/sendMembercard",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          dispatch.serviceSetting.getServiceSetting(); // Cập nhât lại list service setting
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async sendMembercardForCustomerList(payload, rootState) {
      let phoneList = [];
      if (payload.idList.length) {
        let idList = payload.idList;
        idList.forEach((item) => {
          phoneList.push({ ...item, isCustomer: true });
        });
      }
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      let data = {
        phoneList: phoneList,
        memberCardSend: payload.memberCardSend,
        methodSend: payload.methodSend,
      };
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI + Channel + "/api/secure/userMembercards/sendMembercard",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    getDetailByCode(payload, rootState) {
      const _this = this;
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI + Channel + "/api/secure/userMembercards/getDetailByCode",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(payload),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          // console.log(result);
          _this.setState({
            listOrderUserMembercard: result.data.listOrder,
            userMemberCard: result.data.userMemberCard,
          });
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
  }),
};

export default userMembercard;
